module.exports = __webpack_public_path__ + "img/bounding-box.35e0bd75.svg";